import { BORDER_RADIUS, FONT_SIZE, FONT_WEIGHT } from '@app/style/constants';
import { Flex } from 'antd';
import styled from 'styled-components';

export const StyledResourceCard = styled(Flex)`
	border-radius: ${BORDER_RADIUS};
	padding: 16px;

	span.title {
		font-size: ${FONT_SIZE.md};
		font-weight: ${FONT_WEIGHT.medium};
	}

	span:not(.title) {
		font-size: ${FONT_SIZE.xs};
	}

	&:not(.main) {
		background-color: var(--white);
	}

	&:not(.main) {
		background-color: var(--white);

		.ant-divider {
			background-color: var(--grayLight);
		}

		.nomenclature-wrapper span {
			color: var(--gray);
		}
	}

	&.main {
		background-color: var(--green);

		.title {
			color: var(--greenUltraLight);
		}

		.ant-divider {
			background-color: var(--greenLight);
		}

		.nomenclature-wrapper:not(.uah) span {
			color: var(--greenLight);
		}

		.nomenclature-wrapper.uah span {
			color: var(--greenUltraLight);
		}
	}
`;
